import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { appConfig } from "../configs/tenantConfig";
import { tenant } from "../tenant";

import homeAuthPagesEn from "./locales/en/homeAuthPages.json";
import navbarEn from "./locales/en/navbar.json";
import sidebarEn from "./locales/en/sidebar.json";
import verifyEn from "./locales/en/verify.json";
import transactionEn from "./locales/en/transaction.json";
import requestEn from "./locales/en/request.json";
import settingsEn from "./locales/en/settings.json";
import profileEn from "./locales/en/profile.json";
import resetPasswordEn from "./locales/en/resetPassword.json";
import publicPortalEn from "./locales/en/publicPortal.json";

import homeAuthPagesPt from "./locales/pt/homeAuthPages.json";
import navbarPt from "./locales/pt/navbar.json";
import sidebarPt from "./locales/pt/sidebar.json";
import verifyPt from "./locales/pt/verify.json";
import transactionPt from "./locales/pt/transaction.json";
import requestPt from "./locales/pt/request.json";
import settingsPt from "./locales/pt/settings.json";
import profilePt from "./locales/pt/profile.json";
import resetPasswordPt from "./locales/pt/resetPassword.json";
import publicPortalPt from "./locales/pt/publicPortal.json";

const resources = {
  en: {
    homeAuthPages: homeAuthPagesEn,
    navbar: navbarEn,
    sidebar: sidebarEn,
    verify: verifyEn,
    transaction: transactionEn,
    request: requestEn,
    settings: settingsEn,
    profile: profileEn,
    resetPassword: resetPasswordEn,
    publicPortal: publicPortalEn,
  },
  pt: {
    homeAuthPages: homeAuthPagesPt,
    navbar: navbarPt,
    sidebar: sidebarPt,
    verify: verifyPt,
    transaction: transactionPt,
    request: requestPt,
    settings: settingsPt,
    profile: profilePt,
    resetPassword: resetPasswordPt,
    publicPortal: publicPortalPt,
  },
};

export function applyTenantOverrides(overridesByLang) {
  if (!overridesByLang) return;

  for (const [lang, namespaces] of Object.entries(overridesByLang)) {
    if (!resources[lang]) continue;
    for (const [ns, overrides] of Object.entries(namespaces)) {
      if (!resources[lang][ns]) continue;
      Object.assign(resources[lang][ns], overrides);
    }
  }
}

applyTenantOverrides(tenant.localeOverrides);

const getDefaultLanguage = () => {
  try {
    const stored = JSON.parse(
      localStorage.getItem("availableLanguages") || "null",
    );
    if (stored && stored.length > 0) {
      if (appConfig.defaultLanguage === "pt") {
        const portuguese = stored.find((language) => language.value === "pt");
        if (portuguese) return "pt";
      }
      return stored[0].value;
    }
  } catch (e) {
    // ignore parse errors
  }
  return appConfig.defaultLanguage;
};

const resolveInitialLanguage = () =>
  localStorage.getItem("selectedLanguage") ||
  localStorage.getItem("i18nextLng") ||
  getDefaultLanguage();

const initialLanguage = resolveInitialLanguage();
localStorage.setItem("selectedLanguage", initialLanguage);
localStorage.setItem("i18nextLng", initialLanguage);
if (typeof document !== "undefined") {
  document.documentElement.lang = initialLanguage;
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    resources,
    debug: process.env.NODE_ENV === "development",
    lng: initialLanguage,
    fallbackLng: appConfig.defaultLanguage,

    ns: [
      "homeAuthPages",
      "navbar",
      "verify",
      "sidebar",
      "transaction",
      "request",
      "settings",
      "profile",
      "resetPassword",
      "publicPortal",
    ],
    defaultNS: "navbar",

    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

i18next.on("languageChanged", (language) => {
  localStorage.setItem("selectedLanguage", language);
  localStorage.setItem("i18nextLng", language);
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
});

export default i18next;
